import { Component, ViewChild, OnInit } from '@angular/core';
import * as moment from 'moment'
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TrainingClass } from '../../models/domain/training.class';
import { AdminItem } from '../../models/domain/admin.item';
import { AddTrainingClassRequest } from '../../models/ss-api/requests/add.training.class.request';
import { TrainingClassTrainerSurveyURL, TrainingClassTrainerSurveyURLArray } from '../../models/domain/training.class.trainer.surveyurl';
import { CKEditorComponent } from 'ng2-ckeditor';
import { EmailTemplateBasicsItem } from '../../../app/models/domain/email.template.basics.item';
import { TemplateTypes } from '../../../app/models/domain/email.template.item';
import { Router } from '@angular/router';
import { VersionItemArray } from '@models/domain/version.item';

class Trainer {
    trainer: AdminItem;
    url: string;
    embedhtml: string;
}

export interface IAddClassDialogModel {
    title: string;
    class: TrainingClass;
    Products: any[];
}

@Component({
    selector: 'add-class-dialog',
    styleUrls: ['./add.class.dialog.css'],
    templateUrl: './add.class.dialog.html'
})

export class AddClassDialog extends DialogComponent<IAddClassDialogModel, boolean> implements IAddClassDialogModel, OnInit {
    IsBusy: boolean = false;
    title: string;
    class: TrainingClass = new TrainingClass();
    Products: any[] = new Array<any>();
    ClassForm: FormGroup;
    Trainers: Array<Trainer> = new Array<Trainer>();
    TrainingEmailTemplates: Array<EmailTemplateBasicsItem>;
    SoftwareVersions: VersionItemArray;
    MinimumSoftwareVersionInt: number = 0;
    MaximumSoftwareVersionInt: number = 0;

    @ViewChild('CKEDITORDESCRIPTION') CKEDITORDESCRIPTION: CKEditorComponent;
    @ViewChild('CKEDITOREXPLANATION') CKEDITOREXPLANATION: CKEditorComponent;
    @ViewChild('CKEDITORFOLLOWUP') CKEDITORFOLLOWUP: CKEditorComponent;

    constructor(private api: ssApiService, dialogService: DialogService, private gb: GlobalService, private sweetAlert: SweetAlertService, public router: Router) {
        super(dialogService, router);
        this.gb.GetStructureStudiosProductsBasics().then(data => {
            console.log("classproducts", data);
            data.filter(p => p.ModuleType == 'PoolStudio' || p.ModuleType == 'VIPD3D' || p.ModuleType == 'VizTerra').forEach(function (product) {
                if (product.ID < 4) {
                    let icon = '';
                    let color = '';
                    switch (product.ID) {
                        case 3:
                            icon = '../../assets/images/icons/logo-icons-vip3d-xs.png';
                            color = '#0064DF';
                            break;
                        case 2:
                            icon = '../../assets/images/icons/logo-icons-pool-studio-xs.png';
                            color = '#FF0000';
                            break
                        case 1:
                            icon = '../../assets/images/icons/logo-icons-vizterra-xs.png';
                            color = '#64A000';
                            break
                    }
                    this.Products.push({
                        label: product.Name,
                        value: product.ID,
                        image: icon,
                        color: color,
                        active: false
                    })
                }
            }, this);
        });
    }

    ngOnInit() {
        //init some basic class fields
        this.class.OrderFormPrice = 0;
        this.class.OrderFormValue = 0;
        this.class.OrderFormVisible = false;
        this.class.OrderFormDisplayName = "";

        // this.getProducts();
        this.InitVersions();
        this.getTrainers();
        this.getTemplates();

        this.ClassForm = new FormGroup({
            'name': new FormControl(this.class.ClassName, [Validators.required, Validators.minLength(5)]),
            'title': new FormControl(this.class.ClassTitle, [Validators.required, Validators.minLength(5)]),
            'preview': new FormControl(this.class.PreviewText, [Validators.required, Validators.minLength(10)]),
            'hours': new FormControl(moment('09:00', 'hh:mm').toDate(), [Validators.required]),
            'credits': new FormControl(this.class.ClassCredits, [Validators.required]),
            'level': new FormControl(this.class.LevelOrder, [Validators.required]),
            'trainer': new FormControl(this.class.TrainerID),
            'explanation': new FormControl(this.class.Explanation),
            'introductoryVideoLabel': new FormControl(this.class.IntroductoryVideoLabel),
            'introductoryVideoURL': new FormControl(this.class.IntroductoryVideoURL),
            'dimensionsGuideLabel': new FormControl(this.class.DimensionsGuideLabel),
            'dimensionsGuideURL': new FormControl(this.class.DimensionsGuideURL),
            'followupSteps': new FormControl(this.class.FollowupSteps),
            'description': new FormControl(this.class.ClassDescription, [Validators.required, Validators.minLength(5)]),
            'fundamentals': new FormControl(this.class.FundamentalsClass),
            'setupEmailTemplate': new FormControl(this.class.EmailTemplateSetup),
            'reminderEmailTemplate': new FormControl(this.class.EmailTemplateReminder),
            'noShowEmailTemplate': new FormControl(this.class.EmailTemplateNoShows),
            'selfCancelEmailTemplate': new FormControl(this.class.EmailTemplateSelfCancel),
            'confirmationEmailTemplate': new FormControl(this.class.EmailTemplateRegistrationConfirmation),
            'certificateEmailTemplate': new FormControl(this.class.EmailTemplateCertificate),
            'trainingDesignURL': new FormControl(this.class.TrainingDesignURL),
            'MinimumSoftwareVersionInt': new FormControl(this.MinimumSoftwareVersionInt),
            'MaximumSoftwareVersionInt': new FormControl(this.MaximumSoftwareVersionInt),
            'OrderFormVisible': new FormControl(this.class.OrderFormVisible),
            'OrderFormDisplayName': new FormControl(this.class.OrderFormDisplayName),
            'OrderFormValue': new FormControl(this.class.OrderFormValue),
            'OrderFormPrice': new FormControl(this.class.OrderFormPrice)
        })
    }

    onProductClick(product) {
        product.active = !product.active;
    }

    // CKEditor Config
    private CKEditorBigConfig = {
        height: '550px'
    }

    InitVersions() {
        let disposable = this.api.GetActiveV3Versions().subscribe(response => {
            if (response.Result) {
                
                var softwareVersions = response.Data;

                var appropriateVersions = new VersionItemArray();
                softwareVersions.forEach((version) => {
                    if (version.VersionInt >= 2024100){
                        appropriateVersions.push(version);
                    }
                });                        

                this.SoftwareVersions = appropriateVersions;
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error Loading Versions',
                    text: response.Message
                }).then(() => { }, () => { });
            }

            disposable.unsubscribe();
        });
        
    }     

    async confirm() {
        // if(!this.ClassForm.valid)
        // return false

        this.IsBusy = true;
        let request: AddTrainingClassRequest = new AddTrainingClassRequest();
        let surveyURLs: TrainingClassTrainerSurveyURLArray = new TrainingClassTrainerSurveyURLArray();
        let fields = this.ClassForm.controls;
        this.class.ProductIDs = [];

        if (this.CKEDITORDESCRIPTION.instance['mode'] != 'wysiwyg') {

            this.CKEDITORDESCRIPTION.instance['commands']['source'].exec()
            setTimeout(() => {
                this.confirm();
            }, 500)

            return false;

        }

        if (this.CKEDITOREXPLANATION.instance['mode'] != 'wysiwyg') {

            this.CKEDITOREXPLANATION.instance['commands']['source'].exec()
            setTimeout(() => {
                this.confirm();
            }, 500)

            return false;

        }

        if (this.CKEDITORFOLLOWUP.instance['mode'] != 'wysiwyg') {

            this.CKEDITORFOLLOWUP.instance['commands']['source'].exec()
            setTimeout(() => {
                this.confirm();
            }, 500)

            return false;

        }

        if (fields.fundamentals.value == null) {
            fields.fundamentals.setValue(false);
        }

        this.Products.forEach(function (product) {
            if (product.active) {
                this.class.ProductIDs.push(product.value);
            }
        }, this)

        // Proof of concept form validation w/ swal errors
        if (!this.class.ProductIDs || this.class.ProductIDs.length == 0) {
            this.showError('Please select a product');
            return false;
        } else {
            request.ProductIDs = this.class.ProductIDs;
        }
        
        request.APSPCertificate = false;


        if (fields.OrderFormPrice.valid){
            request.OrderFormPrice = fields.OrderFormPrice.value;
        }
        else{
            this.showError('Order Form Price must be 0 or a valid amount.');
            return false;
        }

        if (fields.OrderFormValue.valid){
            request.OrderFormValue = fields.OrderFormValue.value;
        }
        else{
            this.showError('Order Form Value must be 0 or a valid amount.');
            return false;
        }

        if (fields.fundamentals.valid) {
            request.FundamentalsClass = fields.fundamentals.value;
        } else {
            this.showError('Please define whether this class is Fundamentals.');
            return false;
        }

        if (fields.credits.valid) {
            request.ClassCredits = fields.credits.value;
        } else {
            this.showError('Please define the credits rewarded by this class');
            return false;
        }

        if (fields.description.valid) {
            request.ClassDescription = fields.description.value;
        } else {
            this.showError('Please add a class description.');
            return false;
        }

        if (fields.hours.valid) {
            request.ClassDuration = moment(fields.hours.value).format('hh:mm:ss');
        } else {
            this.showError('Please add a duration to the class');
            return false;
        }

        if (fields.name.valid) {
            request.ClassName = fields.name.value;
        } else {
            this.showError('Please add a name to the class');
            return false;
        }

        if (fields.title.valid) {
            request.ClassTitle = fields.title.value;
        } else {
            this.showError('Please add a title to the class');
            return false;
        }

        if (fields.preview.valid) {
            request.PreviewText = fields.preview.value;
        } else {
            this.showError('Please add Preview Text to the class');
            return false;
        }

        request.DimensionsGuideLabel = fields.dimensionsGuideLabel.value;
        request.DimensionsGuideURL = fields.dimensionsGuideURL.value;
        request.Explanation = fields.explanation.value;
        request.FollowupSteps = fields.followupSteps.value;
        request.IntroductoryVideoLabel = fields.introductoryVideoLabel.value;
        request.IntroductoryVideoURL = fields.introductoryVideoURL.value;
        request.LevelOrder = fields.level.value;
        request.TrainingDesignURL = fields.trainingDesignURL.value;

        request.EmailTemplateCertificate = fields.certificateEmailTemplate.value;
        request.EmailTemplateNoShows = fields.noShowEmailTemplate.value;
        request.EmailTemplateRegistrationConfirmation = fields.confirmationEmailTemplate.value;
        request.EmailTemplateReminder = fields.reminderEmailTemplate.value;
        request.EmailTemplateSelfCancel = fields.selfCancelEmailTemplate.value;
        request.EmailTemplateSetup = fields.setupEmailTemplate.value;

        request.OrderFormDisplayName = fields.OrderFormDisplayName.value;
        request.OrderFormVisible = fields.OrderFormVisible.value;        

        // request.TrainerID = fields.trainer.value;
        if (!request.ClassDescription || request.ClassDescription.length < 1) {
            request.ClassDescription = '';
        }

        this.Trainers.forEach(function (trainer) {
            let survey: TrainingClassTrainerSurveyURL = new TrainingClassTrainerSurveyURL();
            survey.TrainerID = trainer.trainer.AdminID;
            survey.SurveyURL = trainer.url;
            survey.EmbeddedSurveyHTML = trainer.embedhtml;

            surveyURLs.push(survey);
        })

        request.TrainingClassTrainerSurveyURLs = surveyURLs;

        request.MinimumSoftwareVersionInt = this.MinimumSoftwareVersionInt;
        request.MaximumSoftwareVersionInt = this.MaximumSoftwareVersionInt;

        let disposable = this.api.AddTrainingClass(request).subscribe(response => {
            if (response.Result) {
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Class Added',
                    text: 'Class added without any errors',
                    timer: 1500
                }).then(() => { }, () => { })
                this.close();
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error',
                    text: response.Message
                })
            }
            this.IsBusy = false;
            disposable.unsubscribe();
        })
    }

    showError(error) {
        this.sweetAlert.swal({
            title: 'Whoops!',
            text: error,
            type: 'error'
        })
        this.IsBusy = false;
    }

    private getTrainers() {
        let disposable = this.api.GetTrainers().subscribe(response => {
            response.Data.forEach(function (trainer) {
                let t: Trainer = {
                    trainer: trainer,
                    url: '',
                    embedhtml: ''
                }
                this.Trainers.push(t);
            }, this);
            disposable.unsubscribe();
        })
    }

    private getTemplates() {

        let disposable = this.api.GetEmailTemplatesBasicsAndFrom().subscribe(response => {
            if (response.Result) {
                this.TrainingEmailTemplates = response.Data.Templates.filter(template => template.TemplateType == TemplateTypes.Training);
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error Loading Templates',
                    text: response.Message
                }).then(() => { }, () => { })
            }

            disposable.unsubscribe();
        })
    }

}
